import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Dropdown from './Dropdown';
import MultiChoice from './MultiChoice';
import SingleChoice from './SingleChoice';

let ChoiceID = 0;

const getChild = ({presentation, multiple}) => {
    if (presentation === 'dropdown') return Dropdown;
    if (multiple) return MultiChoice;
    return SingleChoice;
}

class Choice extends Component {

    constructor(props) {
        super(props);
        this.id = ChoiceID++;
    }

    render() {
        const {config, ...props} = this.props;
        let Child = getChild(config);

        return <Child config={config} {...props} id={this.id} />
    }
}

Choice.canContinue = (answer, config = {}) => {
    const {answer_optional: isAnswerOptional} = config;
    if (isAnswerOptional) {
        return false;
    }
    
    return getChild(config).canContinue(answer, config);
};

Choice.propTypes = {
    config: PropTypes.shape({
        presentation: PropTypes.string,
        multiple: PropTypes.bool,
    }),
};

Choice.defaultProps = {
    config: {},
};

export default Choice;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Choice.js